import ArchivedCoursesPage from './ArchivedCoursesPage';
import { ArchivedCoursesPageProps, ArchivedCoursesPageValueProps } from './types';

export type { ArchivedCoursesPageProps, ArchivedCoursesPageValueProps };
export default ArchivedCoursesPage;
